import {Component, Input, OnInit} from '@angular/core';
import {TranslateDirective, TranslatePipe} from "@ngx-translate/core";

@Component({
    selector: 'app-map-primary-button',
    templateUrl: './map-primary-button.component.html',
    styleUrls: ['./map-primary-button.component.scss'],
    imports: [
      TranslatePipe
    ],
  standalone: true
})
export class MapPrimaryButtonComponent implements OnInit {
  @Input() label: string = '';

  constructor() {
  }

  ngOnInit() {
  }

}
